/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddCalcListRequest,
  AddCalcListResponse,
  AllResultsResponse,
  CalcListResponse,
  CustomCalcConditionResponse,
  CustomCalcResultExistsResponse,
  CustomCalcResultResponse,
  HTTPValidationError,
  RequestAllExcelDownloadUrl,
  ResponseDownloadUrl,
} from '../models/index';
import {
    AddCalcListRequestFromJSON,
    AddCalcListRequestToJSON,
    AddCalcListResponseFromJSON,
    AddCalcListResponseToJSON,
    AllResultsResponseFromJSON,
    AllResultsResponseToJSON,
    CalcListResponseFromJSON,
    CalcListResponseToJSON,
    CustomCalcConditionResponseFromJSON,
    CustomCalcConditionResponseToJSON,
    CustomCalcResultExistsResponseFromJSON,
    CustomCalcResultExistsResponseToJSON,
    CustomCalcResultResponseFromJSON,
    CustomCalcResultResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RequestAllExcelDownloadUrlFromJSON,
    RequestAllExcelDownloadUrlToJSON,
    ResponseDownloadUrlFromJSON,
    ResponseDownloadUrlToJSON,
} from '../models/index';

export interface AddCalcListApiApiCustomCalcCalclistPostRequest {
    addCalcListRequest: AddCalcListRequest;
}

export interface CheckCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGetRequest {
    basinId: string;
    filename: string;
}

export interface CustomCalcAllResultsApiApiCustomCalcResultBasinIdAllGetRequest {
    basinId: string;
    filename: string;
}

export interface CustomCalcResultApiApiCustomCalcResultBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    filename: string;
}

export interface GenerateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPostRequest {
    basinId: string;
    filename: string;
    tgttime: string;
    requestAllExcelDownloadUrl: RequestAllExcelDownloadUrl;
}

export interface GenerateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    filename: string;
    tgttime: string;
}

export interface SaveCustomCalcConditionApiApiCustomCalcConditionPostRequest {
    body: object;
}

/**
 * 
 */
export class CustomCalcApi extends runtime.BaseAPI {

    /**
     * CALCLIST.json更新API FEから送られてきたアイテム(fileName, title, description, tgttime)を static2/{project_key}/CALCLIST.json に追加する ファイルが存在しない場合は新規作成する
     * Add Calc List Api
     */
    async addCalcListApiApiCustomCalcCalclistPostRaw(requestParameters: AddCalcListApiApiCustomCalcCalclistPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddCalcListResponse>> {
        if (requestParameters['addCalcListRequest'] == null) {
            throw new runtime.RequiredError(
                'addCalcListRequest',
                'Required parameter "addCalcListRequest" was null or undefined when calling addCalcListApiApiCustomCalcCalclistPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/customCalc/calclist`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCalcListRequestToJSON(requestParameters['addCalcListRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddCalcListResponseFromJSON(jsonValue));
    }

    /**
     * CALCLIST.json更新API FEから送られてきたアイテム(fileName, title, description, tgttime)を static2/{project_key}/CALCLIST.json に追加する ファイルが存在しない場合は新規作成する
     * Add Calc List Api
     */
    async addCalcListApiApiCustomCalcCalclistPost(requestParameters: AddCalcListApiApiCustomCalcCalclistPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddCalcListResponse> {
        const response = await this.addCalcListApiApiCustomCalcCalclistPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カスタム計算結果の存在チェックAPI RESULTS_PATH/{basinId}-customCalc/{filename}.zip が存在するかチェック
     * Check Custom Calc Result Exists Api
     */
    async checkCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGetRaw(requestParameters: CheckCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomCalcResultExistsResponse>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling checkCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGet().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling checkCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customCalc/exists/{basinId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomCalcResultExistsResponseFromJSON(jsonValue));
    }

    /**
     * カスタム計算結果の存在チェックAPI RESULTS_PATH/{basinId}-customCalc/{filename}.zip が存在するかチェック
     * Check Custom Calc Result Exists Api
     */
    async checkCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGet(requestParameters: CheckCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomCalcResultExistsResponse> {
        const response = await this.checkCustomCalcResultExistsApiApiCustomCalcExistsBasinIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カスタム計算のすべての観測所の結果取得API RESULTS_PATH/{basinId}-customCalc/{filename}.zip から全観測所の結果を取得
     * Custom Calc All Results Api
     */
    async customCalcAllResultsApiApiCustomCalcResultBasinIdAllGetRaw(requestParameters: CustomCalcAllResultsApiApiCustomCalcResultBasinIdAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllResultsResponse>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling customCalcAllResultsApiApiCustomCalcResultBasinIdAllGet().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling customCalcAllResultsApiApiCustomCalcResultBasinIdAllGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customCalc/result/{basinId}/all`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllResultsResponseFromJSON(jsonValue));
    }

    /**
     * カスタム計算のすべての観測所の結果取得API RESULTS_PATH/{basinId}-customCalc/{filename}.zip から全観測所の結果を取得
     * Custom Calc All Results Api
     */
    async customCalcAllResultsApiApiCustomCalcResultBasinIdAllGet(requestParameters: CustomCalcAllResultsApiApiCustomCalcResultBasinIdAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllResultsResponse> {
        const response = await this.customCalcAllResultsApiApiCustomCalcResultBasinIdAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カスタム計算結果取得API RESULTS_PATH/{basinId}-customCalc/{filename}.zip から結果を取得
     * Custom Calc Result Api
     */
    async customCalcResultApiApiCustomCalcResultBasinIdStationIdGetRaw(requestParameters: CustomCalcResultApiApiCustomCalcResultBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomCalcResultResponse>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling customCalcResultApiApiCustomCalcResultBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling customCalcResultApiApiCustomCalcResultBasinIdStationIdGet().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling customCalcResultApiApiCustomCalcResultBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customCalc/result/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomCalcResultResponseFromJSON(jsonValue));
    }

    /**
     * カスタム計算結果取得API RESULTS_PATH/{basinId}-customCalc/{filename}.zip から結果を取得
     * Custom Calc Result Api
     */
    async customCalcResultApiApiCustomCalcResultBasinIdStationIdGet(requestParameters: CustomCalcResultApiApiCustomCalcResultBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomCalcResultResponse> {
        const response = await this.customCalcResultApiApiCustomCalcResultBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カスタム計算結果の複数Excelファイル取得（ZIP形式） lambdaを使用してFastApiから直接zipファイルをダウンロードすると壊れる為 S3へのアップロード後にダウンロード用urlを発行して返す
     * Generate All Custom Calc Excel Download Url Api
     */
    async generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPostRaw(requestParameters: GenerateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDownloadUrl>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPost().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPost().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPost().'
            );
        }

        if (requestParameters['requestAllExcelDownloadUrl'] == null) {
            throw new runtime.RequiredError(
                'requestAllExcelDownloadUrl',
                'Required parameter "requestAllExcelDownloadUrl" was null or undefined when calling generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/customCalc/allExcel/{basinId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestAllExcelDownloadUrlToJSON(requestParameters['requestAllExcelDownloadUrl']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDownloadUrlFromJSON(jsonValue));
    }

    /**
     * カスタム計算結果の複数Excelファイル取得（ZIP形式） lambdaを使用してFastApiから直接zipファイルをダウンロードすると壊れる為 S3へのアップロード後にダウンロード用urlを発行して返す
     * Generate All Custom Calc Excel Download Url Api
     */
    async generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPost(requestParameters: GenerateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDownloadUrl> {
        const response = await this.generateAllCustomCalcExcelDownloadUrlApiApiCustomCalcAllExcelBasinIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カスタム計算結果のExcelファイル取得
     * Generate Custom Calc Excel Download Url Api
     */
    async generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGetRaw(requestParameters: GenerateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDownloadUrl>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGet().'
            );
        }

        if (requestParameters['filename'] == null) {
            throw new runtime.RequiredError(
                'filename',
                'Required parameter "filename" was null or undefined when calling generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filename'] != null) {
            queryParameters['filename'] = requestParameters['filename'];
        }

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customCalc/excel/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDownloadUrlFromJSON(jsonValue));
    }

    /**
     * カスタム計算結果のExcelファイル取得
     * Generate Custom Calc Excel Download Url Api
     */
    async generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGet(requestParameters: GenerateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDownloadUrl> {
        const response = await this.generateCustomCalcExcelDownloadUrlApiApiCustomCalcExcelBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CALCLIST.json取得API static2/{project_key}/CALCLIST.json の内容を取得する ファイルが存在しない場合は空のリストを返す
     * Get Calc List Api
     */
    async getCalcListApiApiCustomCalcCalclistGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalcListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customCalc/calclist`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalcListResponseFromJSON(jsonValue));
    }

    /**
     * CALCLIST.json取得API static2/{project_key}/CALCLIST.json の内容を取得する ファイルが存在しない場合は空のリストを返す
     * Get Calc List Api
     */
    async getCalcListApiApiCustomCalcCalclistGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalcListResponse> {
        const response = await this.getCalcListApiApiCustomCalcCalclistGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * カスタム計算条件保存API FEから送られてきた条件オブジェクトを static2/{project_key}/customCalcCondition/ に保存 既存ファイル数+1の番号でCALC{n}.jsonとして保存する
     * Save Custom Calc Condition Api
     */
    async saveCustomCalcConditionApiApiCustomCalcConditionPostRaw(requestParameters: SaveCustomCalcConditionApiApiCustomCalcConditionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomCalcConditionResponse>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling saveCustomCalcConditionApiApiCustomCalcConditionPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/customCalc/condition`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomCalcConditionResponseFromJSON(jsonValue));
    }

    /**
     * カスタム計算条件保存API FEから送られてきた条件オブジェクトを static2/{project_key}/customCalcCondition/ に保存 既存ファイル数+1の番号でCALC{n}.jsonとして保存する
     * Save Custom Calc Condition Api
     */
    async saveCustomCalcConditionApiApiCustomCalcConditionPost(requestParameters: SaveCustomCalcConditionApiApiCustomCalcConditionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomCalcConditionResponse> {
        const response = await this.saveCustomCalcConditionApiApiCustomCalcConditionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
